import { Box } from "@chakra-ui/react";
import { Navbar } from "../components/landing/Navbar";
import { Footer } from "../components/landing/Footer";
import { PageHero } from "../components/common/PageHero";
import { SectionWrapper } from "../components/common/SectionWrapper";
import { SectionIntro } from "../components/about/SectionIntro";
import { SectionHistory } from "../components/about/SectionHistory";
import { SectionTeam } from "../components/about/SectionTeam";
import { SectionGovernance } from "../components/about/SectionGovernance";
import { SectionStructure } from "../components/about/SectionStructure";
import { SectionLicenses } from "../components/about/SectionLicenses";
import { SectionShareholders } from "../components/about/SectionShareholders";
import { SectionCSR } from "../components/about/SectionCSR";
import { SectionAwards } from "../components/about/SectionAwards";

export const AboutUsPage = () => {
  const scrollToGrid = () => {
    const el = document.getElementById("intro");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <Box dir="rtl" overflowX="hidden">
      <Navbar />
      <PageHero
        title="مسیر رشد و اعتماد با"
        titleHighlight="تأمین سرمایه امید"
        subtitle="آشنایی با ساختار، تیم، ارزش‌ها و خدمات ما در بازار سرمایه ایران"
        primaryAction={{
          label: "آشنایی بیشتر با ما",
          onClick: scrollToGrid,
        }}
      />
      <SectionWrapper id="intro">
        <SectionIntro />
      </SectionWrapper>
      <SectionWrapper id="history" alt>
        <SectionHistory />
      </SectionWrapper>
      <SectionWrapper id="team">
        <SectionTeam />
      </SectionWrapper>
      <SectionWrapper id="structure">
        <SectionStructure />
      </SectionWrapper>
      <SectionWrapper id="governance" alt>
        <SectionGovernance />
      </SectionWrapper>
      <SectionWrapper id="licenses" alt>
        <SectionLicenses />
      </SectionWrapper>
      <SectionWrapper id="shareholders">
        <SectionShareholders />
      </SectionWrapper>
      <SectionWrapper id="awards" alt>
        <SectionAwards />
      </SectionWrapper>
      <SectionWrapper id="csr">
        <SectionCSR />
      </SectionWrapper>
      <Footer />
    </Box>
  );
};
